'use client'

import { PlanCard } from '@/components/plan/Card'
import { usePlethoreForm } from '@/contexts/FormContext'
import { requiredRule } from '@/utils/rules'
import { Flex, Form, Input } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { SBDynamicFormInput } from './types'

const SBDynamicFormInputPlan: SBDynamicFormInput = ({ name }) => {
  const { t } = useTranslation('form')
  const form = Form.useFormInstance()
  const { plans, onSelectedPlanChanged } = usePlethoreForm()

  const planValue = Form.useWatch(name, form)

  useEffect(() => {
    if (plans.length === 1 && !planValue) {
      const [onlyPlan] = plans
      form.setFieldValue(name, onlyPlan.id)
      onSelectedPlanChanged(onlyPlan)
    }
  }, [plans, planValue, form, name, onSelectedPlanChanged])

  return (
    <Flex vertical gap={16}>
      <Form.Item name={name} noStyle rules={[requiredRule(t)]}>
        <Input type="hidden" />
      </Form.Item>

      {plans.map((plan) => (
        <PlanCard
          key={plan.id}
          plan={plan}
          displayDescriptions
          isSelected={planValue && planValue == plan.id}
          onClick={() => {
            form.setFieldValue(name, plan.id)
            onSelectedPlanChanged(plan)
          }}
        />
      ))}
    </Flex>
  )
}

export { SBDynamicFormInputPlan }
